// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import { GameFragmentDoc } from '../../../client/shared/graphql/GameFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GameCarouselQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Types.CasinoGameConnectionSorter>;
  filter: Types.CasinoGameConnectionFilter;
  first: Types.Scalars['Int']['input'];
  language: Types.Scalars['String']['input'];
  currency?: Types.InputMaybe<Types.currencyConversion>;
}>;


export type GameCarouselQuery = { __typename?: 'Query', casino?: { __typename?: 'Casino', id: string, games?: { __typename?: 'CasinoGameConnection', edges?: Array<{ __typename?: 'CasinoGameEdge', node?: { __typename?: 'CasinoGame', id: string, name?: string, handle?: string, thumbUrl?: string, thumbUrlTab?: string, href?: string, isTrending?: boolean, isHot?: boolean, isNew?: boolean, isHighRoller?: boolean, isFavourite?: boolean, inLoyalty?: boolean, rtp?: number, rtpLivePastDay?: number, rtpLivePastSevenDays?: number, rtpLivePastThirtyDays?: number, isFeatured?: boolean, minBet?: number, maxBet?: number, menuItem?: Array<{ __typename?: 'CasinoGameMenuItem', id: string, handle?: string, name?: string }>, themes?: { __typename?: 'CasinoGameThemeConnection', edges?: Array<{ __typename?: 'CasinoGameThemeEdge', node?: { __typename?: 'CasinoGameTheme', id: string, name?: string, handle?: string } }> } } }> } } };

export type GameEdgeFragment = { __typename?: 'CasinoGameEdge', node?: { __typename?: 'CasinoGame', id: string, name?: string, handle?: string, thumbUrl?: string, thumbUrlTab?: string, href?: string, isTrending?: boolean, isHot?: boolean, isNew?: boolean, isHighRoller?: boolean, isFavourite?: boolean, inLoyalty?: boolean, rtp?: number, rtpLivePastDay?: number, rtpLivePastSevenDays?: number, rtpLivePastThirtyDays?: number, isFeatured?: boolean, minBet?: number, maxBet?: number, menuItem?: Array<{ __typename?: 'CasinoGameMenuItem', id: string, handle?: string, name?: string }>, themes?: { __typename?: 'CasinoGameThemeConnection', edges?: Array<{ __typename?: 'CasinoGameThemeEdge', node?: { __typename?: 'CasinoGameTheme', id: string, name?: string, handle?: string } }> } } };

export const GameEdgeFragmentDoc = /*#__PURE__*/ gql`
    fragment GameEdgeFragment on CasinoGameEdge {
  node {
    ...GameFragment
  }
}
    ${GameFragmentDoc}`;
export const GameCarouselQueryDocument = /*#__PURE__*/ gql`
    query GameCarouselQuery($sort: CasinoGameConnectionSorter, $filter: CasinoGameConnectionFilter!, $first: Int!, $language: String!, $currency: currencyConversion) {
  casino {
    id
    games(
      filter: $filter
      first: $first
      language: $language
      sort: $sort
      hrefPrefix: "/play"
    ) {
      edges {
        ...GameEdgeFragment
      }
    }
  }
}
    ${GameEdgeFragmentDoc}`;
export function useGameCarouselQuery(baseOptions: Apollo.QueryHookOptions<GameCarouselQuery, GameCarouselQueryVariables> & ({ variables: GameCarouselQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameCarouselQuery, GameCarouselQueryVariables>(GameCarouselQueryDocument, options);
      }
export function useGameCarouselQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameCarouselQuery, GameCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameCarouselQuery, GameCarouselQueryVariables>(GameCarouselQueryDocument, options);
        }
export function useGameCarouselQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GameCarouselQuery, GameCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GameCarouselQuery, GameCarouselQueryVariables>(GameCarouselQueryDocument, options);
        }
export type GameCarouselQueryHookResult = ReturnType<typeof useGameCarouselQuery>;
export type GameCarouselQueryLazyQueryHookResult = ReturnType<typeof useGameCarouselQueryLazyQuery>;
export type GameCarouselQuerySuspenseQueryHookResult = ReturnType<typeof useGameCarouselQuerySuspenseQuery>;
export type GameCarouselQueryQueryResult = Apollo.QueryResult<GameCarouselQuery, GameCarouselQueryVariables>;